<div
  class="avatar-container"
  [ngStyle]="{ 'background-color': bgColor }"
  matTooltip="{{ name }} - {{ email }}"
>
  <span class="initials">{{ initials }}</span>
</div>
